import React, { useState } from 'react';
import { api, DEMO } from '../api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('master_admin');
  const [err, setErr] = useState('');

  async function submit(e) {
    e.preventDefault();
    setErr('');
    try {
      const res = DEMO ? await api.loginDemoAs(role) : await api.login(email.trim(), password.trim());
      onLogin(res.user);
    } catch (ex) {
      setErr((ex.response && ex.response.data && ex.response.data.detail) || ex.message || 'Sign-in failed');
    }
  }

  async function microsoft() {
    setErr('');
    try {
      const { msalEnabled, msalLoginPopup } = await import('../msal');
      if (!msalEnabled) { setErr('Microsoft sign-in is not configured for this environment yet.'); return; }
      const idToken = await msalLoginPopup();
      const res = await api.microsoft(idToken);
      onLogin(res.user);
    } catch (ex) {
      if (ex && (ex.errorCode === 'user_cancelled' || ex.errorCode === 'popup_window_error')) {
        setErr(ex.errorCode === 'user_cancelled' ? 'Sign-in cancelled.' : 'Popup was blocked — allow popups for this site and try again.');
        return;
      }
      const detail = ex && ex.response && ex.response.data && ex.response.data.detail;
      setErr(detail || (ex && ex.message) || 'Microsoft sign-in failed');
    }
  }

  return (
    <div className="auth-overlay">
      <div className="auth-card">
        <h1>LPA Datasheet Generator</h1>
        <p>Sign in to continue</p>
        <div className="auth-error">{err}</div>
        {!DEMO && (
          <>
            <button type="button" className="auth-ms" data-testid="login-ms-btn" onClick={microsoft}>
              <svg viewBox="0 0 21 21" width="16" height="16"><rect width="9" height="9" x="1" y="1" fill="#f25022"/><rect width="9" height="9" x="11" y="1" fill="#7fba00"/><rect width="9" height="9" x="1" y="11" fill="#00a4ef"/><rect width="9" height="9" x="11" y="11" fill="#ffb900"/></svg>
              Sign in with Microsoft
            </button>
            <div className="auth-divider"><span>or with email</span></div>
          </>
        )}
        <form onSubmit={submit}>
          {DEMO ? (
            <>
              <label>Demo mode — sign in as</label>
              <select className="input" value={role} onChange={e => setRole(e.target.value)}>
                <option value="master_admin">Master Admin</option>
                <option value="sales_tech">Sales &amp; Technical</option>
                <option value="guest">Guest</option>
              </select>
            </>
          ) : (
            <>
              <label>Email or username</label>
              <input type="text" data-testid="login-email-input" value={email} onChange={e => setEmail(e.target.value)} autoCapitalize="none" autoCorrect="off" autoComplete="username" spellCheck={false} required />
              <label>Password</label>
              <input type="password" data-testid="login-password-input" value={password} onChange={e => setPassword(e.target.value)} autoCapitalize="none" autoCorrect="off" autoComplete="current-password" spellCheck={false} required />
            </>
          )}
          <button type="submit" className="auth-submit" data-testid="login-submit-btn">{DEMO ? 'Continue' : 'Sign in'}</button>
        </form>
        {DEMO && <div className="field-hint" style={{ marginTop: 12, textAlign: 'center' }}>No backend configured — running in local demo mode (data stays in this browser).</div>}
      </div>
    </div>
  );
}
